export interface UploadProgress {
  bytesTransferred: number;
  totalBytes: number;
  percentage: number;
}

export interface UploadResult {
  url: string;
  path: string;
  size: number;
}

export abstract class CloudStorageProvider {
  abstract uploadFile(
    file: File,
    path: string,
    onProgress?: (progress: UploadProgress) => void
  ): Promise<UploadResult>;

  abstract downloadFile(path: string): Promise<Blob>;

  abstract deleteFile(path: string): Promise<void>;

  abstract getFileUrl(path: string): Promise<string>;

  abstract listFiles(path: string): Promise<string[]>;
}
